$ = require 'jquery'
{ map, reject, isUndefined } = require 'lodash'

module.exports =
  ###
  @param $el [jQueryObject] element
  @return [String] background-image url
  ###
  getBgImg: ($el) ->
    bgImg = $el.css 'background-image'
    if bgImg isnt 'none'
      imgs = map bgImg.split(','), (img) ->
        img.match(/^url\(['"]?(.+[0-9a-zA-Z])['"]?\)$/)?[1]
      reject(imgs, isUndefined)[0]



// WEBPACK FOOTER //
// ./webpack/requires/components/css-val.coffee